import { enumify } from '../lib/typeInference.js';

export const walletPassTypeValues = [
    "APPLE",
    "GOOGLE"
] as const;
export type WalletPassType = typeof walletPassTypeValues[number];
export const WalletPassTypeEnum = enumify(walletPassTypeValues);
